  import React, { useState, useEffect } from 'react';
  import {
    Typography,
    Paper,
    Alert,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Box,
    InputAdornment,
    Grid,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Button,
    MenuItem,
    FormControl,
    Select,
    InputLabel,
    Tabs,
    Tab,
    Stack
  } from '@mui/material';
  import { DataGrid } from '@mui/x-data-grid';
  import EditIcon from '@mui/icons-material/Edit';
  import SearchIcon from '@mui/icons-material/Search';
  import EditCategoryGroupForm from './EditCategoryGroupForm';
  import { fetchKitchens } from '../../../../services/dashboard/apiServiceDashboard';
  import DeleteIcon from '@mui/icons-material/Delete';
  import { changeCategoryGroupStatus } from '../../../../services/menuPage';



  const CategoryGroupTabs = ({ groups, loading, error, onUpdate }) => {
    const [tabIndex, setTabIndex] = useState(0);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [kitchenFilter, setKitchenFilter] = useState('');
    const [kitchens, setKitchens] = useState([]);

    useEffect(() => {
      const loadKitchens = async () => {
        try {
          const res = await fetchKitchens();
          // توقع أن البيانات تحت res.data.data
          if (res && res.data && Array.isArray(res.data.data)) {
            setKitchens(res.data.data);
          } else if (Array.isArray(res)) {
            setKitchens(res);
          }
        } catch {
          setKitchens([]);
        }
      };
      loadKitchens();
    }, []);

    const filteredGroups = groups?.filter(group => {
      const matchesSearch = group.name?.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesKitchen = kitchenFilter ? group.kitchen_id === kitchenFilter : true;
      return matchesSearch && matchesKitchen;
    });
    const getKitchenName = (id) => {
    const kitchen = kitchens.find(k => String(k.id) === String(id));
    return kitchen ? kitchen.name : `ID: ${id}`;
  };


    const tableRows = filteredGroups.map(group => ({
      id: group.id,
      name: group.name,
      note: group.note || '—',
      kitchen_id: group.kitchen_id,
      status: group.status, // إضافة الحالة للجدول
    }));

    const handleDeleteGroup = async (groupId, groupName) => {
      if (!window.confirm(`هل أنت متأكد أنك تريد تغيير حالة المجموعة "${groupName}"؟`)) return;
      try {
        await changeCategoryGroupStatus(groupId);
        if (onUpdate) onUpdate();
      } catch (err) {
        alert("❌ فشل في تغيير حالة المجموعة.");
      }
    };

  const tableColumns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'name', headerName: 'اسم المجموعة', flex: 1, minWidth: 150 },
    { field: 'note', headerName: 'ملاحظة', flex: 1, minWidth: 150 },
    {
      field: 'kitchen_id',
      headerName: 'اسم المطبخ',
      width: 180,
      renderCell: (params) => {
        const kitchen = kitchens.find(k => String(k.id) === String(params.value));
        return kitchen ? kitchen.name : params.value;
      }
    },
    {
      field: 'status',
      headerName: 'الحالة',
      width: 120,
      renderCell: (params) => (
        params.value === 1 ? '✅ مفعل' : '🚫 غير مفعل'
      )
    },
    {
      field: 'actions',
      headerName: 'الإجراءات',
      width: 120,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <IconButton
            sx={{ color: 'red' }}
            onClick={() => handleDeleteGroup(params.row.id, params.row.name)}
          >
            <DeleteIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => setSelectedGroup(params.row)}
          >
            <EditIcon />
          </IconButton>
        </Stack>
      )
    }
  ];


    if (loading) return <Typography>⏳ جاري التحميل...</Typography>;
    if (error) return <Alert severity="error">{error}</Alert>;
    if (!groups || groups.length === 0) return <Alert severity="info">🚫 لا توجد مجموعات أصناف حتى الآن.</Alert>;

    return (
      <Paper sx={{ padding: 3, mt: 2 }}>
        <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)} sx={{ mb: 3 }}>
          <Tab label="بطاقات المجاميع" />
          <Tab label="عرض كجدول" />
        </Tabs>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
          <TextField
            placeholder="🔍 ابحث باسم المجموعة"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />

          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>تصفية حسب المطبخ</InputLabel>
            <Select
              value={kitchenFilter}
              onChange={(e) => setKitchenFilter(e.target.value)}
              label="تصفية حسب المطبخ"
            >
              <MenuItem value="">الكل</MenuItem>
              {kitchens.map((kitchen) => (
                <MenuItem key={kitchen.id} value={kitchen.id}>{kitchen.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {tabIndex === 0 && (
          filteredGroups.filter(group => group.status === 1).length === 0 ? (
            <Alert severity="info">لا توجد نتائج مطابقة.</Alert>
          ) : (
            <Grid container spacing={3}>
              {filteredGroups
                .filter(group => group.status === 1)
                .map(group => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={group.id}>
                    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                      {group.image && (
                        <CardMedia
                          component="img"
                          height="140"
                          image={`http://moumen01.restocash.app/${group.image}`}
                          alt={group.name}
                        />
                      )}
                      <CardContent>
                        <Typography variant="h6" gutterBottom>{group.name}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          🧾 {group.note || 'لا توجد ملاحظات'}<br />
                          🍽 مطبخ: {getKitchenName(group.kitchen_id)}
                        </Typography>
                      </CardContent>
                      <CardActions sx={{ mt: 'auto', justifyContent: 'flex-end' }}>
                        <IconButton
                          color="primary"
                          onClick={() => setSelectedGroup(group)}
                          aria-label="edit"
                        >
                          <EditIcon />
                        </IconButton>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          )
        )}

      {tabIndex === 1 && (
          <Box sx={{ height: 500, width: '100%' }}>
            <DataGrid
              rows={tableRows}
              columns={tableColumns}
              pageSize={8}
              rowsPerPageOptions={[8, 16, 32]}
              disableRowSelectionOnClick
            />
          </Box>
        )}

        <Dialog
          open={!!selectedGroup}
          onClose={() => setSelectedGroup(null)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>✏️ تعديل بيانات المجموعة</DialogTitle>
          <DialogContent>
            {selectedGroup && (
              <EditCategoryGroupForm
                initialData={selectedGroup}
                onSuccess={() => {
                  setSelectedGroup(null);
                  if (onUpdate) onUpdate();
                }}
              />
            )}
          </DialogContent>
        </Dialog>
      </Paper>
    );
  };

  export default CategoryGroupTabs;
